<!-- eslint-disable indent -->
<template>
  <v-layout
    row
    class="mt-5 mb-4"
    style="padding-bottom: 60px;"
  >
    <v-flex
      xs12
      sm12
      md10
      offset-md1
      lg8
      offset-lg2
    >
      <v-card
        flat
        color="white"
        class="elevation-9"
      >
        <v-card-title
          primary-title
          class="grey lighten-4 pl-4"
        >
          <h3 class="headline mb-0"><span v-if="company">{{ company.name }}</span> Datencheck</h3>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>

          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex
                xs12
                md8
                class="pr-5 subheading"
              >
                <p class="headline">
                  Sehr geehrtes Innungsmitglied,
                </p>
                <p>
                 ein Vorteil Ihrer Mitgliedschaft in der <strong>{{ company.innungen[0].name }}</strong> ist der kostenlose Basiseintrag auf LokalesHandwerk.de.</p>

                 


                 <p>
                 Um Ihre Daten aktuell zu halten, möchten wir Sie bitten, den untenstehenden  Datencheck auszufüllen. Diese Anfrage ist bis zum <strong>{{ date }}</strong> aktiv. Nach Ablauf können Sie jederzeit unter info@lokaleshandwerk.de einen neuen Datencheck anfragen.</p>
                <p>
                 Mit folgenden Daten sind Sie auf LokalesHandwerk.de sowie weiteren Betriebesuchen registriert:

                </p>
                
              </v-flex>

              <v-flex
                xs12
                md4
                class="text-truncate text-xs-left mt-5"
                v-if="company"
              >
                <p class="subheading">
                  Vorschau Ihres Profils:
                </p>
                <v-btn
                  class="pr-4 pl-0 py-4 mt-3 subheading"
                  style="text-transform: none; min-height: 70px; line-height: 1.5;"
                  large
                  block
                  color="accent"
                  :to="{
                    name: 'showCompany',
                    params: { id: company.slug }
                  }"
                >
                 {{ company.name }} <br>auf LokalesHandwerk.de
                 <v-icon large right>ads_click</v-icon>
                </v-btn>

                <!-- <v-btn
                      class="mx-auto mt-4 pt-2 pb-2"
                      large
                      block
                      color="green"
                      dark
                      @click="confirmData()"
                      :loading="saveloading"
                    >
                      Angaben speichern
                    </v-btn> -->
              </v-flex>
              <v-flex
                v-else
                xs12
                sm5
                class="text-xs-center"
              >
                <v-progress-circular
                  indeterminate
                  color="accent"
                  :width="3"
                ></v-progress-circular>

              </v-flex>

            </v-layout>

            <v-layout
              row
              wrap
              class="mt-3"
              v-if="company"
            >
              <!-- <v-flex
                xs12
                md12
              >
                <v-card flat color="transparent">
                  <v-card-text class="px-0">
                    <p class="headline mb-0 pb-0">Ihre Daten</p> 
                  </v-card-text>
                </v-card>
             </v-flex> -->
              <v-flex
                xs12
                md6
              >
                <v-card
                  flat
                  color="transparent"
                >
                  <v-card-text class="px-0 pb-0">
                    <p class="title">Ihr Betrieb</p>
                     <p class="subheading">Geben Sie hier Ihren Unternehmensnamen ein:</p>
                    <v-layout
                      row
                      wrap
                    >
                      <v-flex
                        xs12
                        sm11
                      >
                        <v-text-field
                          height="65"
                          outline
                          class="headline"
                          counter="80"
                          hint="This field uses counter prop"
                          label="Angezeigter Name Ihres Betriebs"
                          v-model="company.name"
                        ><template v-slot:prepend-inner>
                            <v-icon class="mr-2">chevron_right</v-icon>
                          </template></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-card-text>

                  
                </v-card>
              </v-flex>

              <v-flex
                xs12
                md6
              >
                <v-card
                  flat
                  color="transparent"
                   v-if="abgefragteLeistungen.length > 0"
                >
                  <v-card-text class="px-0">
                    <p class="title">Leistungen auswählen</p>
                     <p class="subheading">Mit folgenden Leistungen können Sie sich aktuell direkt verknüpfen lassen:</p>
                    <v-layout
                      row
                      wrap
                    >
                      <v-flex
                        xs12
                        md12
                        class="xtext-xs-center"
                      >
                        <confirm-leistung
                          v-for="leistung in abgefragteLeistungen"
                          :key="leistung.id"
                          :leistung="leistung"
                          :betrieb="company"
                          @calledback="calledback()"
                        ></confirm-leistung>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex
                xs12
                md6
                class="mt-4"
              >
                <v-card
                  flat
                  color="transparent"
                >
                  <v-card-text class="px-0">
                    <p class="title">Kontaktmöglichkeiten für Kunden</p>
                    <p class="subheading">Hier können Sie Ihre öffentlichen Kontaktdaten eintragen:</p>
                    <v-layout
                      row
                      wrap
                    >
                      <v-flex
                        xs12
                        sm11
                      >
                        <v-text-field
                          outline
                          label="Telefon"
                          v-model="company.telefon"
                        ><template v-slot:prepend-inner>
                            <v-icon class="mr-3">phone</v-icon>
                          </template></v-text-field>
                      </v-flex>

                      <v-flex
                        xs12
                        sm11
                      >
                        <v-text-field
                          outline
                          label="E-Mail"
                          v-model="company.email"
                        >
                          <template v-slot:prepend-inner>
                            <v-icon class="mr-3">mail</v-icon>
                          </template>
                        </v-text-field>
                      </v-flex>
                      <v-flex
                        xs12
                        sm11
                      >
                        <v-text-field
                          outline
                          placeholder="https://"
                          hint="Bitte mit https:// angeben"
                          label="Webseite"
                          v-model="company.website"
                        >
                          <template v-slot:prepend-inner>
                            <v-icon class="mr-3">monitor</v-icon>
                          </template>
                        </v-text-field>
                      </v-flex>

                    </v-layout>
                  </v-card-text>
                  <v-card-text class="text-xs-center pl-0 pr-5 mt-0">
                    <v-btn
                      class="mx-auto"
                      large
                      block
                      color="green"
                      dark
                      @click="confirmData()"
                      :loading="saveloading"
                    >
                      Angaben speichern<v-icon right>done</v-icon></v-btn>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex
                xs12
                md6
                class="mt-4"
              >
                <v-card
                  flat
                  color="transparent"
                >
                  <v-card-text class="px-0">
                    <p class="title">Adresse Ihres Betriebs</p>
                     <p class="subheading">Angaben aus der Handwerksrolle Ihrer Kreishandwerkerschaft. Änderungen können nur über Ihre Kreishandwerkerschaft veranlasst werden. Optional können Sie den Stadtteil ergänzen.</p>
                    <v-layout
                      row
                      wrap
                    >
                      <v-flex xs12>
                        <v-text-field
                          outline
                          disabled
                          label="Name aus der Handwerksrolle"
                          v-model="company.offiziellername"
                        ><template v-slot:prepend-inner>
                            <v-icon class="mr-3">badge</v-icon>
                          </template></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          outline
                          disabled
                          label="Straße + Hausnummer"
                          v-model="company.address"
                        ><template v-slot:prepend-inner>
                            <v-icon class="mr-3">signpost</v-icon>
                          </template></v-text-field>
                      </v-flex>
                      <v-flex xs3>
                        <v-text-field
                          outline
                          disabled
                          label="PLZ"
                          v-model="company.plz"
                        ><template v-slot:prepend-inner>
                            <v-icon class="mr-2">location_on</v-icon>
                          </template></v-text-field>
                      </v-flex>
                      <v-flex xs5>
                        <v-text-field
                          outline
                          disabled
                          label="Stadt"
                          v-model="company.stadt"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs4>
                        <v-text-field
                          outline
                          label="Stadtteil"
                          v-model="company.stadtteil"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>

                  </v-card-text>

                </v-card>
              </v-flex>
              <v-flex
                xs12
                md6
              >
                <v-card
                  flat
                  color="transparent"
                >
                  <v-card-text class="px-0">
                    <p class="title">Innungsmitgliedschaft</p>
                    <v-layout
                      row
                      wrap
                      v-for="innung in company.innungen"
                      :key="innung.id"
                    >
                      <v-flex
                        md3
                        class="subheading"
                      >
                        <v-img
                          v-if="innung.logo"
                          :src="innung.logo"
                          max-height="80px"
                          contain
                        ></v-img>
                      </v-flex>
                      <v-flex
                        md9
                        align-self-center
                        class="subheading pl-3"
                      >
                        {{ innung.name }}
                      </v-flex>
                    </v-layout>

                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex
                xs12
                md6
              >
                <v-card
                  flat
                  color="transparent"
                >
                  <v-card-text class="px-0">
                    <p class="title">Verknüpfte Leistungen</p>
                    <v-layout
                      row
                      wrap
                    >
                        <div
                          v-for="leistung in company.leistungen"
                          :key="leistung.id"
                          class="text-truncate"
                        >
                          <v-btn
                            flat
                            class="grey lighten-2 text-none ma-1 py-1"
                            style="border-radius: 2px;"
                            text-color="grey darken-4"
                          >
                            <v-icon
                              left
                              color="grey lighten-5"
                            >label</v-icon>
                            <h4 class="subheading">{{ leistung.leistung }}</h4>
                          </v-btn>
                        </div>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>

              <!-- <v-flex
                xs12
                md12
              >
                <v-card
                  flat
                  color="transparent"
                >
                  <v-card-text class="px-0">
                    <p class="headline">Sind die Daten noch korrekt?</p>
                    <p class="subheading">Bitte teilen Sie uns mit, wenn sich Ihre Kontaktdaten geändert haben.</p>
                    <p class="subheading">

                      <v-btn href="mailto:info@lokaleshandwerk.de">
                        <v-icon left>mail</v-icon>info@lokaleshandwerk.de
                      </v-btn>

                      <v-btn to="/mitmachen">
                        <v-icon left>login</v-icon>verwalten Sie ihren Betrieb selbst
                      </v-btn>

                      
                    </p>
                  </v-card-text>
                </v-card>
              </v-flex> -->
            </v-layout>

            <v-layout
              row
              v-else
            >
              <v-flex
                xs12
                class="text-xs-center mt-5"
              >
                <v-progress-circular
                  indeterminate
                  color="accent"
                ></v-progress-circular>

              </v-flex>
            </v-layout>

            <!-- <v-layout
              row
              wrap
            >
              <v-flex xs12>
                <v-card
                  flat
                  color="transparent"
                >
                  <p class="headline">Fragen & Antworten</p>
                  <v-expansion-panel>
                    <v-expansion-panel-content>
                      <template v-slot:header>
                        <div class="subheading">Was genau bedeutet das?</div>
                      </template>
                      <v-card>
                        <v-card-text>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</v-card-text>
                      </v-card>
                    </v-expansion-panel-content>
                    <v-expansion-panel-content>
                      <template v-slot:header>
                        <div class="subheading">Wer steht hinter diesem Projekt?</div>
                      </template>
                      <v-card>
                        <v-card-text>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</v-card-text>
                      </v-card>
                    </v-expansion-panel-content>
                    <v-expansion-panel-content>
                      <template v-slot:header>
                        <div class="subheading">Sind mit dem Eintrag irgendwelche Kosten verbunden?</div>
                      </template>
                      <v-card>
                        <v-card-text>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</v-card-text>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-card>
              </v-flex>
            </v-layout> -->
            <!-- <v-layout v-if="company">
  <v-flex>{{company}}</v-flex>
</v-layout> -->
            <v-layout
              row
              wrap
            >
              <v-flex
                xs12
                md6
              >
                <v-card
                  max-width="500"
                  flat
                  color="transparent"
                  class="pl-0 py-2"
                >
                  <v-img
                    aspect-ratio
                    max-height="104"
                    contain
                    position="left"
                    src="img/kreishandwerkerschaften.png"
                  ></v-img>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'
import confirmLeistung from '~/components/datencheck/confirmLeistung.vue'

export default {
  components: {
    confirmLeistung
  },
  data () {
    return {
      company: '',
      busy: true,
      loading: false,
      saveloading: false,
      date: ''
    }
  },
  mounted: function () {
    this.setDate()
    this.getData()
  },
  metaInfo () {
    return { title: 'Datencheck' }
  },
  computed: {
    isSolarteur: function () {
      if (this.company) {
        if (this.company.leistungen) {
          var arrR = this.company.leistungen.filter(function (ele) {
            return ele.id === 95
          })
          if (arrR.length) {
            return true
          } else {
            return false
          }
        }
      }
    },
    abgefragteLeistungen: function () {
      if (this.company) {
        if (this.company.innungen) {
          const temp = []
          this.company.innungen[0].gewerk[0].leistung.forEach((item) => {
            if (item.abfrage === '1') {
              temp.push(item)
            }
          })
          return temp
          // return this.company.innungen[0].gewerk[0].leistung
        } else {
          return 0
        }
      }
    }
  },
  methods: {
    containsKey (obj, key) {
      return Object.keys(obj).includes(key)
    },
    setDate () {
      const self = this
      const datelimit = new Date(self.$store.state.route.query.expires * 1000)
      this.date = datelimit.toLocaleDateString('de-DE', {})
    },
    getData () {
      const self = this
      axios
        .get('/api/v1/companycomplete/' + this.$store.state.route.query.slug)
        .then((resp) => {
          self.company = resp.data
        })
        .catch((error) => {
          console.log('betrieb nicht gefunden:')
          console.log(error)
        })
    },
    confirmData () {
      this.saveloading = true
      const daten = {
        company: this.company,
        route: this.$store.state.route,
        signature: this.$store.state.route.query.signature
      }

      axios
        .post('datenconfirm', daten)
        .then((resp) => {
          this.$store.dispatch('responseMessage', {
            type: 'success',
            title: 'Erfolgreich gemeldet ',
            text: 'Daten erfolgreich geändert!'
          })
          this.loading = false
        })
        .catch((resp) => {
          console.log('error: ')
          console.log(resp)
          this.$store.dispatch('responseMessage', {
            type: 'error',
            title: 'Da ist leider etwas schiefgegangen',
            text: 'Fehlgeschlagen, bitte kontaktieren Sie info@lokaleshandwerk.de'
          })
        })
        .finally(() => {
          this.getData()
          this.saveloading = false
        })
    },
    calledback () {
      this.getData()
    }
  }
}
</script>


